//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.2.0.0 (NJsonSchema v11.1.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { Constants } from '../../common/Constants';
import { IHttpInfo } from '../../logger';
import { newGuid } from '../../utilities/AppUtils';
import { AuthHelper } from '../../utilities/AuthHelper';
import { getAppHost } from '../../utilities/TeamsUtils';
import { tryParseAfdRefHeader } from '../../utilities/Utils';
export class EsignBaseClient {
    readonly clientRequestIdHeader = Constants.CLIENT_REQUESTID_HEADER;
    private startTime: number;
    private requestId: string;
    private method: string;
    protected async transformOptions(options: RequestInit): Promise<RequestInit> {
        const headers = options.headers as any;
        headers.authorization = 'Bearer ' + (await AuthHelper.getApprovalsToken());
        this.startTime = performance.now();
        if (!headers[this.clientRequestIdHeader]) {
            // set the clientRequestId if it's not present.
            headers[this.clientRequestIdHeader] = newGuid();
        }

        this.requestId = headers[this.clientRequestIdHeader];
        this.method = options.method;
        return Promise.resolve(options);
    }
    protected transformResult(url: string, response: Response, processor: (response: Response) => any): Promise<any> {
        const status = response ? response.status : 0;
        const edgeRef = tryParseAfdRefHeader(response);
        if (status >= 400 || status < 200) {
            console.error(`Server request failed, url: ${url}, status ${status}`);
        }
        const regex = /\/esign\/([a-zA-Z0-9]+)/;
        const apiName = url.match(regex)[0].toString();
        // TODO: add host name
        const httpRequest: IHttpInfo = {
            apiName,
            url,
            clientRequestId: this.requestId,
            correlationId: this.requestId,
            latency: performance.now() - this.startTime,
            requestCreatedTime: this.startTime.toString(),
            responseCode: status,
            responseText: response.statusText,
            requestMethod: this.method,
            edgeRef,
        };
        getAppHost().getLogger().logHttp(httpRequest);
        return processor(response);
    }
    protected getBaseUrl(token: string, baseUrl: string): string {
        return baseUrl ? baseUrl : ESIGN_SERVICE_ENDPOINT;
    }
}

export class Client extends EsignBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * This function gets the admin settings tor the current tenant.
     * @return The esign provider settings for the tenant.
     */
    getSettings(): Promise<ProviderFlags> {
        let url_ = this.baseUrl + "/esign/v1.0/settings/admin/providers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSettings(_response));
        });
    }

    protected processGetSettings(response: Response): Promise<ProviderFlags> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProviderFlags;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderFlags>(null as any);
    }

    /**
     * The function that sets the provider flags.
     * @param providerFlags The provider flags.
     * @return A Task`1 representing the result of the asynchronous operation.
     */
    updateSettings(providerFlags: ProviderFlags): Promise<ProviderFlags> {
        let url_ = this.baseUrl + "/esign/v1.0/settings/admin/providers";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(providerFlags);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateSettings(_response));
        });
    }

    protected processUpdateSettings(response: Response): Promise<ProviderFlags> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProviderFlags;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderFlags>(null as any);
    }
}

export class CreateAdaptiveCardClient extends EsignBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Endpoint for sending an adaptive card.
     * @param input Input containing the envelope and Teams channel data.
     * @return A task.
     */
    createAdaptiveCard(input: CreateAdaptiveCardAdobeControllerInput): Promise<CreateAdaptiveCardControllerOutput> {
        let url_ = this.baseUrl + "/esign/v1.0/createAdaptiveCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateAdaptiveCard(_response));
        });
    }

    protected processCreateAdaptiveCard(response: Response): Promise<CreateAdaptiveCardControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAdaptiveCardControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAdaptiveCardControllerOutput>(null as any);
    }
}

export class DeleteAdaptiveCardClient extends EsignBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Endpoint for sending an adaptive card.
     * @param input Input containing the envelope and Teams channel data.
     * @return A task.
     */
    deleteAdaptiveCard(input: WebhookBaseDataObject): Promise<void> {
        let url_ = this.baseUrl + "/esign/v1.0/deleteAdaptiveCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteAdaptiveCard(_response));
        });
    }

    protected processDeleteAdaptiveCard(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class ReviewEnvelopeClient extends EsignBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * The controller to review an envelope.
     * @param reviewEnvelopeInput The review envelope input object.
     * @return A Task`1 representing the result of the asynchronous operation.
     */
    reviewEnvelope(reviewEnvelopeInput: ReviewEnvelopeInput): Promise<ReviewApprovalControllerOutput> {
        let url_ = this.baseUrl + "/esign/v1.0/ReviewEnvelope";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reviewEnvelopeInput);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviewEnvelope(_response));
        });
    }

    protected processReviewEnvelope(response: Response): Promise<ReviewApprovalControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReviewApprovalControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReviewApprovalControllerOutput>(null as any);
    }
}

export class UserSettingsClient extends EsignBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Controller API endpoint for getting user settings that are controlled by tenant admins.
     * @return A Task`1 representing the result of the asynchronous operation.
     */
    getProviderFlags(): Promise<ProviderFlags> {
        let url_ = this.baseUrl + "/esign/v1.0/settings/user/providers";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProviderFlags(_response));
        });
    }

    protected processGetProviderFlags(response: Response): Promise<ProviderFlags> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProviderFlags;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProviderFlags>(null as any);
    }
}

export class CreateAdaptiveCardDocusignClient extends EsignBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Endpoint for sending an adaptive card.
     * @param input Input containing the envelope and Teams channel data.
     * @return A task.
     */
    createAdaptiveCard(input: CreateAdaptiveCardDocusignControllerInput): Promise<CreateAdaptiveCardControllerOutput> {
        let url_ = this.baseUrl + "/esign/v1.0/Docusign/createAdaptiveCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateAdaptiveCard(_response));
        });
    }

    protected processCreateAdaptiveCard(response: Response): Promise<CreateAdaptiveCardControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateAdaptiveCardControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateAdaptiveCardControllerOutput>(null as any);
    }
}

export class DeleteAdaptiveCardDocusignClient extends EsignBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * Endpoint for sending an adaptive card.
     * @param input Input containing the envelope and Teams channel data.
     * @return A task.
     */
    deleteAdaptiveCard(input: WebhookBaseDataObject): Promise<void> {
        let url_ = this.baseUrl + "/esign/v1.0/Docusign/deleteAdaptiveCard";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(input);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteAdaptiveCard(_response));
        });
    }

    protected processDeleteAdaptiveCard(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }
}

export class EditDocusignEnvelopeAuditEventsClient extends EsignBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * The controller to edit an envelope.
     * @param editEnvelopeInput The edit envelope input object.
     * @return A Task`1 representing the result of the asynchronous operation.
     */
    editDocusignEnvelopeAuditEvents(editEnvelopeInput: EditEnvelopeInput): Promise<EditApprovalControllerOutput> {
        let url_ = this.baseUrl + "/esign/v1.0/Docusign/EditEnvelopeAuditEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(editEnvelopeInput);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEditDocusignEnvelopeAuditEvents(_response));
        });
    }

    protected processEditDocusignEnvelopeAuditEvents(response: Response): Promise<EditApprovalControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EditApprovalControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditApprovalControllerOutput>(null as any);
    }
}

export class ReviewDocusignEnvelopeAuditEventsClient extends EsignBaseClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = this.getBaseUrl("", baseUrl);
    }

    /**
     * The controller to review an envelope.
     * @param reviewEnvelopeInput The review envelope input object.
     * @return A Task`1 representing the result of the asynchronous operation.
     */
    reviewDocusignEnvelopeAuditEvents(reviewEnvelopeInput: ReviewEnvelopeInput): Promise<ReviewApprovalControllerOutput> {
        let url_ = this.baseUrl + "/esign/v1.0/Docusign/ReviewEnvelopeAuditEvents";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(reviewEnvelopeInput);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.http.fetch(url_, transformedOptions_);
        }).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processReviewDocusignEnvelopeAuditEvents(_response));
        });
    }

    protected processReviewDocusignEnvelopeAuditEvents(response: Response): Promise<ReviewApprovalControllerOutput> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ReviewApprovalControllerOutput;
            return result200;
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ReviewApprovalControllerOutput>(null as any);
    }
}

/** The Esign provider settings object. */
export interface ProviderFlags {
    /** Gets or sets a value indicating whether the adobe sign provider is set. */
    AdobeSignProvider: boolean;
    /** Gets or sets a value indicating whether the Docusign provider is enabled. */
    DocusignProvider: boolean;
    /** Gets or sets a value indicating whether the Request Comments sign provider is set. */
    RequestCommentsProvider: boolean;
}

/** Controller output for sending envelope as an adaptive card. Holds the message id. */
export interface CreateAdaptiveCardControllerOutput {
    /** Gets or sets the message id. */
    MessageId?: string | undefined;
}

/** Controller input for sending envelope as an adaptive card. */
export interface CreateAdaptiveCardAdobeControllerInput {
    /** Gets or sets the envelope input. */
    EnvelopeData?: CreateEnvelopeInput | undefined;
}

/** Data object used to call the create approval handler. */
export interface CreateApprovalControllerInput {
    /** Gets or sets the creator of approval request. */
    Creator?: ApprovalCreator | undefined;
    /** Gets or sets the Name of user. */
    UserName?: string | undefined;
    /** Gets or sets the Email of user. */
    UserEmail?: string | undefined;
    /** Gets or sets the title. */
    Title?: string | undefined;
    /** Gets or sets the users AadId to which the approval is assigned. An array of user AadIds. */
    AssignedTo?: string[] | undefined;
    /** Gets or sets the users Name to which the approval is assigned. An array of Names. It will be used only by bot to create adaptive card. */
    ApproverNames?: string[] | undefined;
    /** Gets or sets the type of approval to create. */
    Type: ApprovalResponseType;
    /** Gets or sets the notification url. */
    CallbackUrls?: string[] | undefined;
    /** Gets or sets the details. */
    Details?: string | undefined;
    /** Gets or sets the item to approve. */
    Item?: ApprovalItem | undefined;
    /** Gets or sets the Text Attachment to approve. */
    TextAttachments?: ApprovalsTextAttachment[] | undefined;
    /** Gets or sets the response options for the custom response approval. */
    ResponseOptions?: string[] | undefined;
    /** Gets or sets the ClientRequestId for approval request. */
    ClientRequestId: string;
    /** Gets or sets the Approval Type. */
    ApprovalType: ApprovalType;
    /** Gets or sets the logger properties for a scenario coming in from client-side. */
    ScenarioLoggerProperties?: AriaScenarioLoggerProperties | undefined;
    /** Gets or sets a value indicating whether the tenant is provisioning with this action. */
    FirstTimeProvisioning?: boolean | undefined;
    /** Gets or sets the environment in which Approval is created. */
    FlowEnvironment?: string | undefined;
    /** Gets or sets the Approvals User Token. This is used for bot context messages extension submit action. */
    UserToken?: string | undefined;
    /** Gets or sets the category of the approval. */
    Category?: string | undefined;
    /** Gets or sets the Id of the template with which the approval is created. */
    TemplateId?: string | undefined;
    /** Gets or sets the Id of the form response user submitted to create the approval. */
    TemplateResponseId?: string | undefined;
    /** Gets or sets the source of the approval. */
    Source?: string | undefined;
    /** Gets or sets the priority of the approval. */
    Priority?: Priority | undefined;
    /** Gets or sets the PartnerMetadata Object. */
    PartnerMetadata?: ApprovalsPartnerMetadata | undefined;
    /** Gets or sets the Steps Object. */
    Steps?: ApprovalStepSettingInput[] | undefined;
    /** Gets or sets the Answers of the report. */
    Answers?: AnswerByQuestion[] | undefined;
}

/** Incoming data object for create esign envelope requests. */
export interface CreateEnvelopeInput extends CreateApprovalControllerInput {
    /** Gets or sets the envelope provider token. */
    EsignToken?: string | undefined;
    /** Gets or sets the envelope provider api endpoint. */
    ApiEndpoint?: string | undefined;
    /** Gets or sets the participant details of the agreement. */
    ParticipantDetails?: ParticipantDetails[] | undefined;
    /** Gets or sets the sign approval type. */
    SignApprovalType: SignApprovalType;
    /** Gets or sets the state of the esign envelope. */
    State: AgreementState;
    /** Gets or sets the file attachment for the esign approval. */
    EsignItem?: EsignApprovalItem | undefined;
    /** Gets or sets the webhook data object. */
    WebhookBaseDataObject?: WebhookBaseDataObject | undefined;
}

/** This class holds information about a participant in an agreement. */
export interface ParticipantDetails {
    /** Gets or sets the email of the participant. */
    Email?: string | undefined;
    /** Gets or sets the full name of the participant. */
    FullName?: string | undefined;
    /** Gets or sets the role of the participant for the agreement. */
    Role: ParticipantRole;
    /** Gets or sets the order at which the participant needs to sign the agreement. */
    Order: number;
}

/** The enumeration of the different participant roles. */
export enum ParticipantRole {
    SIGNER = 0,
    APPROVER = 1,
    SENDER = 2,
    FORM_FILLER = 3,
    CC = 4,
    VIEWER = 5,
    ACCEPTOR = 6,
    CERTIFIED_RECIPIENT = 7,
    DELEGATE_TO_SIGNER = 8,
    DELEGATE_TO_APPROVER = 9,
    DELEGATE_TO_FORM_FILLER = 10,
    DELEGATE_TO_ACCEPTOR = 11,
    DELEGATE_TO_CERTIFIED_RECIPIENT = 12,
    SHARE = 13,
    OTHER = 14,
}

/** The types of e-sign approvals that users can create, maps to the Provider drop down within eSign Request Type in UI.. */
export enum SignApprovalType {
    Adobe = 0,
    Docusign = 1,
}

/** Model for agreement states. */
export enum AgreementState {
    Authoring = 0,
    Draft = 1,
    In_Process = 2,
}

/** Items that requires to be approved. */
export interface ApprovalItem {
    /** Gets or sets the item link. */
    Link?: string | undefined;
    /** Gets or sets the item link description. */
    LinkDescription?: string | undefined;
}

/** An esign approval item to hold attributes specific to esign items. */
export interface EsignApprovalItem extends ApprovalItem {
    /** Gets or sets the transient document id of the document. */
    TransientDocumentId?: string | undefined;
    /** Gets or sets the library document id of the document. */
    LibraryDocumentId?: string | undefined;
}

/** Base class for callback data. */
export interface WebhookBaseDataObject {
    /** Gets or sets the ServiceUrl of the bot message posted while creating the approval request.. */
    ServiceUrl?: string | undefined;
    /** Gets or sets the MessageId of the bot message posted while creating the approval request. */
    MessageId?: string | undefined;
    /** Gets or sets the ConversationId of the bot message posted while creating the approval request. */
    ConversationId?: string | undefined;
    /** Gets or sets the ChannelId of the bot message posted while creating the approval request. */
    ChannelId?: string | undefined;
    /** Gets or sets a value indicating from where approval is created. */
    ApprovalCreator: ApprovalCreator;
    /** Gets or sets the AADGroupId of teams team. */
    AadGroupId?: string | undefined;
    /** Gets or sets the cultureInfo when adaptive card is created. */
    Culture?: string | undefined;
    /** Gets or sets the MRI(BotUserId) of creator of Approvals. */
    MRI?: string | undefined;
    /** Gets or sets the approval event type. */
    Type?: string | undefined;
    /** Gets or Sets the Approval Type. */
    ApprovalType: ApprovalType;
}

/** Creator of approval request. */
export enum ApprovalCreator {
    PersonalApp = 0,
    ChatMessage = 1,
    ChannelPost = 2,
    WordAddIn = 3,
    ApprovalGraph = 4,
    UnSpecified = 5,
}

/** The types of approvals that users can create, maps to the Request type drop down in UI. */
export enum ApprovalType {
    Basic = 0,
    ESign = 1,
    Templated = 2,
}

/** Approval response types. */
export enum ApprovalResponseType {
    NotSpecified = 0,
    Basic = 1,
    BasicAwaitAll = 2,
    CustomResponse = 3,
    CustomResponseAwaitAll = 4,
    Sequential = 5,
}

/** Link attachments that require to be approved. */
export interface ApprovalsTextAttachment {
    /** Gets or sets the subject. */
    Subject?: string | undefined;
    /** Gets or sets the link. */
    NoteText?: string | undefined;
}

/** Aria logger properties received from client-side. */
export interface AriaScenarioLoggerProperties {
    /** Gets or sets the session ID. */
    SessionId: string;
    /** gets or sets the scenario name. */
    ScenarioName?: string | undefined;
    /** gets or sets the scenario name. */
    StepName?: string | undefined;
    /** gets or sets the status. */
    Status?: string | undefined;
    /** gets or sets the approval id. */
    ApprovalId?: string | undefined;
    /** gets or sets additional data received from telemetry logger. */
    Data?: any | undefined;
}

/** The priority of the approval. */
export enum Priority {
    Low = 0,
    Medium = 1,
    Important = 2,
}

/** PartnerMetadata Object for Approvals. */
export interface ApprovalsPartnerMetadata {
    /** Gets or sets approvalsTemplateResponse details. */
    ApprovalsTemplateResponse?: ApprovalsTemplateResponseItem[] | undefined;
    /** Gets or sets the viva amplify additional information. */
    VivaAmplifyAdditionalDetails?: VivaAmplifyAdditionalDetails | undefined;
    /** Gets or sets the Syntex Esign additional information. */
    SyntexESignMetadata?: SyntexESignMetadata | undefined;
    /** Gets or sets other properties in the metadata.
It's preferred to define a strong type property when you add a new field in the metadata. */
    AdditionalData?: { [key: string]: any; } | undefined;
}

/** ResponseItem (Answer + Question Snapshot) for Template Approvals. */
export interface ApprovalsTemplateResponseItem {
    /** Gets or sets id map the form question. */
    questionId?: string | undefined;
    /** Gets or sets question type. */
    type: TemplateQuestionType;
    /** Gets or sets question anwser string or jsonstring. */
    answer?: string | undefined;
    /** Gets or sets question title. */
    title?: string | undefined;
    /** Gets or sets a value indicating whether this field is required. */
    required: boolean;
    /** Gets or sets all choices of the question. */
    chocies?: string[] | undefined;
    /** Gets or sets Froms Rich Text Title. */
    formsProRTQuestionTitle?: string | undefined;
}

/** Quesiton Type. Save and transfer this data as string. [EnumMember(Value = "xx")] dose not work with System.Text.Json. So we use under line to split subtype.the enum filed name cannot be changed once published. */
export enum TemplateQuestionType {
    TextField_Single = "TextField_Single",
    TextField_Multiline = "TextField_Multiline",
    Choice_SingleRadio = "Choice_SingleRadio",
    Choice_SingleDropdown = "Choice_SingleDropdown",
    Choice_MultiCheckbox = "Choice_MultiCheckbox",
    DateTime_Default = "DateTime_Default",
    TextField_Number = "TextField_Number",
}

/** Addtional details for the Viva Amplify approvals. */
export interface VivaAmplifyAdditionalDetails {
    /** Gets or sets the teams Id. */
    teamsId?: string | undefined;
    /** Gets or sets the Channel id. */
    channelId?: string | undefined;
    /** Gets or sets the publish date of the item in UTC format. */
    scheduledPublishDate?: string | undefined;
    /** Gets or sets the approval type of the viva campaign communication. */
    approvalType?: string | undefined;
    /** Gets or sets the message from the requestor. */
    messageFromRequestor?: string | undefined;
    /** Gets or sets the distribution channel. */
    distributionChannel?: DistributionChannel[] | undefined;
    /** Gets or sets the publish option for Item. */
    publishOption?: PublishOption | undefined;
    /** Gets or sets the abstract of the campaign approval item. */
    itemTitle?: string | undefined;
    /** Gets or sets the abstract of the campaign approval item. */
    itemAbstract?: string | undefined;
    /** Gets or sets the url of the campaign approval item. */
    itemUrl?: string | undefined;
    /** Gets or sets the preview image of the campaign approval item. */
    itemPreviewImageUrl?: string | undefined;
}

/** Enum for the distribution channels. */
export enum DistributionChannel {
    Outlook = "outlook",
    Sharepoint = "sharepoint",
    Teams = "teams",
    VivaEngage = "vivaengage",
}

/** Enum for the publish option. */
export enum PublishOption {
    ScheduledFor = "scheduledFor",
    PublishOnceApproved = "publishOnceApproved",
    ReviewBeforePublish = "reviewBeforePublish",
}

/** Additional Details for Syntex Esign Approvals. */
export interface SyntexESignMetadata {
    /** Gets or sets the locale for the approval. */
    Locale?: string | undefined;
    /** Gets or sets the target folder for the Esign documents. */
    TargetFolder?: string | undefined;
    /** Gets or sets the documents associated with the approval. */
    Documents?: SyntexESignDocument[] | undefined;
    /** Gets or sets the message associated with the approval. */
    Message?: string | undefined;
    /** Gets or sets the status associated with the approval. */
    Status?: number | undefined;
}

/** Syntex Esign Document Object. */
export interface SyntexESignDocument {
    /** Gets or sets the name of the Syntex document. */
    Name?: string | undefined;
    /** Gets or sets the Uri for the Syntex document. */
    Uri?: string | undefined;
}

/** Settings for one step in Sequential approval. */
export interface ApprovalStepSettingInput {
    /** Gets or sets the users to which the approval is assigned as approvers.
An array of Object IDs or Emails. */
    AssignedTo?: string[] | undefined;
    /** Gets or sets the users Name to which the approval is assigned. An array of Names. It will be used only by bot to create adaptive card. */
    ApproverNames?: string[] | undefined;
    /** Gets or sets the response options. */
    ResponseOptions?: string[] | undefined;
    /** Gets or sets the approval policy. */
    ApprovalPolicy: ApprovalPolicyType;
}

/** The approval policy: any ,all. */
export enum ApprovalPolicyType {
    Any = 1,
    All = 2,
}

/** The data model of AnswerByQuestion. The answer can be identified by the question id in a report context. */
export interface AnswerByQuestion {
    /** Gets or sets the QuestionId. */
    QuestionId?: string | undefined;
    /** Gets or sets the AnswerContent. */
    AnswerContent?: string | undefined;
}

/** Data object used to call the review approval controller. */
export interface ReviewApprovalControllerOutput {
    /** Gets or sets the name of the approval. */
    Name?: string | undefined;
    /** Gets or sets the id of the approval. */
    Id?: string | undefined;
    /** Gets or sets the type of the approval. */
    Type?: string | undefined;
}

/** Input data object for review approval controller. */
export interface ReviewApprovalControllerInput {
    /** Gets or sets the approval request id. */
    ApprovalId: string;
    /** Gets or sets the envelope external id. */
    ExternalId?: string | undefined;
    /** Gets or sets the ClientRequestId for approvalrequest. */
    ClientRequestId: string;
    /** Gets or sets the approval environment. */
    FlowEnvironment?: string | undefined;
}

/** The input class for review envelope. */
export interface ReviewEnvelopeInput extends ReviewApprovalControllerInput {
    /** Gets or sets the envelope ID. */
    EnvelopeId?: string | undefined;
}

/** Controller input for sending envelope as an adaptive card. */
export interface CreateAdaptiveCardDocusignControllerInput {
    /** Gets or sets the envelope input. */
    EnvelopeData?: DraftEnvelopeInput | undefined;
}

/** Draft envelope input. */
export interface DraftEnvelopeInput extends CreateApprovalControllerInput {
    /** Gets or sets the envelope provider token. */
    EsignToken?: string | undefined;
    /** Gets or sets the envelope provider api endpoint. */
    ApiEndpoint?: string | undefined;
    /** Gets or sets the participant details of the agreement. */
    ParticipantDetails?: ParticipantDetails[] | undefined;
    /** Gets or sets the sign approval type. */
    SignApprovalType: SignApprovalType;
    /** Gets or sets the file name. */
    DocumentName?: string | undefined;
    /** Gets or sets the file content in base64. */
    DocumentBase64?: string | undefined;
    /** Gets or sets the webhook data object. */
    WebhookBaseDataObject?: WebhookBaseDataObject | undefined;
    /** Gets or sets a value indicating whether the envelope is in draft mode. */
    IsDraft: boolean;
}

/** Data object used to call the edit approval controller. */
export interface EditApprovalControllerOutput {
    /** Gets or sets the name of the approval. */
    Name?: string | undefined;
    /** Gets or sets the id of the approval. */
    Id?: string | undefined;
}

/** The input class for edit envelope. */
export interface EditEnvelopeInput {
    /** Gets or sets the envelope ID. */
    EnvelopeId?: string | undefined;
    /** Gets or sets the approval request id. */
    ApprovalId: string;
    /** Gets or sets the envelope external id. */
    ExternalId?: string | undefined;
    /** Gets or sets the ClientRequestId for approvalrequest. */
    ClientRequestId: string;
    /** Gets or sets the approval environment. */
    FlowEnvironment?: string | undefined;
}

export class ServiceException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isServiceException = true;

    static isServiceException(obj: any): obj is ServiceException {
        return obj.isServiceException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ServiceException(message, status, response, headers, null);
}

/*
 *  Copyright © Microsoft Corporation. All rights reserved.
 *
 *  Base Class for auto-generated nSwag code under `../gen/index.ts`. The code in this file can be modified if needed,
 *  but make sure to run the build of Approvals.SFApp/Approvals.Service to update the auto-generated code, and check in
 *  the auto-generated code as well.
 *
 *  The auto-generated code under `../gen/index.ts` is the code that actually gets to run.
 */

declare const ESIGN_SERVICE_ENDPOINT: string;